import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "spin"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ion-text-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  class: "ion-padding-top",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_8 = { class: "ion-text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", { src: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjYzVkYmZmIiBkPSJNMCAwaDUxMnY1MTJIMHoiLz48cGF0aCBkPSJNMjU2IDMwNGM2MS42IDAgMTEyLTUwLjQgMTEyLTExMlMzMTcuNiA4MCAyNTYgODBzLTExMiA1MC40LTExMiAxMTIgNTAuNCAxMTIgMTEyIDExMnptMCA0MGMtNzQuMiAwLTIyNCAzNy44LTIyNCAxMTJ2NTZoNDQ4di01NmMwLTc0LjItMTQ5LjgtMTEyLTIyNC0xMTJ6IiBmaWxsPSIjODJhZWZmIi8+PC9zdmc+" }, null, -1)
const _hoisted_10 = { style: {"white-space":"pre-line"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_image_slides = _resolveComponent("image-slides")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString($setup.loading ? '...' : $setup.getLocalizedStr($setup.product, 'title', 'titleEn')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_back_button, {
                    "default-href": $setup.parentPath ? $setup.parentPath : '/products'
                  }, null, 8, ["default-href"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          ($setup.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_ion_spinner)
              ]))
            : _createCommentVNode("", true),
          (!$setup.loading && $setup.product)
            ? (_openBlock(), _createBlock(_component_ion_grid, {
                key: 1,
                fixed: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    class: "ion-text-center",
                                    "size-xs": "12",
                                    "size-md": "6"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("img", {
                                        src: $setup.product.imageLink
                                      }, null, 8, _hoisted_2),
                                      ($setup.product.photoLinks.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createVNode(_component_image_slides, {
                                              imageLinks: $setup.product.photoLinks,
                                              minSlidesPerView: 3,
                                              size: "small",
                                              hideEyeIcon: true,
                                              defaultCaption: $setup.getLocalizedStr($setup.product, 'title', 'titleEn')
                                            }, null, 8, ["imageLinks", "defaultCaption"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_card_header, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_card_title, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h2", null, _toDisplayString($setup.getLocalizedStr($setup.product, 'title', 'titleEn')), 1)
                                            ]),
                                            _: 1
                                          }),
                                          ($setup.product.sellingPrice != $setup.product.price)
                                            ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                                key: 0,
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("s", null, "HK$" + _toDisplayString(Number($setup.product.price).toLocaleString()), 1),
                                                  _createTextVNode(" HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createBlock(_component_ion_card_title, {
                                                key: 1,
                                                color: "primary"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(" HK$" + _toDisplayString(Number($setup.product.sellingPrice).toLocaleString()), 1)
                                                ]),
                                                _: 1
                                              }))
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_ion_card_content, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_row, null, {
                                            default: _withCtx(() => [
                                              ($setup.loadingProductVariants)
                                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                                    key: 0,
                                                    size: "12"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_4, [
                                                        _createVNode(_component_ion_spinner)
                                                      ])
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_ion_col, {
                                                    key: 1,
                                                    size: "12",
                                                    class: "ion-no-padding"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      ($setup.productVariants.length > 0)
                                                        ? (_openBlock(), _createBlock(_component_ion_item, {
                                                            key: 0,
                                                            lines: "none"
                                                          }, {
                                                            default: _withCtx(() => [
                                                              _createVNode(_component_ion_select, {
                                                                interface: "popover",
                                                                modelValue: $setup.selectedProductVariant,
                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.selectedProductVariant) = $event))
                                                              }, {
                                                                default: _withCtx(() => [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productVariants, (variant) => {
                                                                    return (_openBlock(), _createBlock(_component_ion_select_option, {
                                                                      key: variant.id,
                                                                      value: variant
                                                                    }, {
                                                                      default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(variant.title), 1)
                                                                      ]),
                                                                      _: 2
                                                                    }, 1032, ["value"]))
                                                                  }), 128))
                                                                ]),
                                                                _: 1
                                                              }, 8, ["modelValue"])
                                                            ]),
                                                            _: 1
                                                          }))
                                                        : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 1
                                          }),
                                          ($setup.selectedProductInStock)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                _createVNode(_component_ion_item, {
                                                  class: "ion-align-items-center ion-no-padding",
                                                  lines: "none"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_button, {
                                                      class: "qty-action-btn",
                                                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.decrementCartItemQty()), ["stop"]))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, {
                                                          slot: "icon-only",
                                                          icon: $setup.remove
                                                        }, null, 8, ["icon"])
                                                      ]),
                                                      _: 1
                                                    }),
                                                    _createElementVNode("input", {
                                                      class: "quantity-input",
                                                      type: "number",
                                                      min: "0",
                                                      max: "99",
                                                      step: "1",
                                                      value: $setup.cartItemQty,
                                                      onBlur: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.onFinishInputCartItemQty($event)), ["stop"])),
                                                      placeholder: "0"
                                                    }, null, 40, _hoisted_6),
                                                    _createVNode(_component_ion_button, {
                                                      class: "qty-action-btn",
                                                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => ($setup.incrementCartItemQty()), ["stop"]))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, {
                                                          slot: "icon-only",
                                                          icon: $setup.add
                                                        }, null, 8, ["icon"])
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_button, {
                                                  class: "ion-margin-bottom",
                                                  expand: "block",
                                                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => ($setup.addProductToCart($setup.product, $setup.selectedProductVariant)), ["stop"]))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      slot: "start",
                                                      icon: $setup.cartOutline
                                                    }, null, 8, ["icon"]),
                                                    _createTextVNode(" " + _toDisplayString($setup.t('addToCart')), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                ($setup.userLoggedIn)
                                                  ? (_openBlock(), _createBlock(_component_ion_button, {
                                                      key: 0,
                                                      class: "ion-margin-bottom",
                                                      expand: "block",
                                                      fill: "outline",
                                                      "router-link": {
                        name: 'CheckoutPage',
                        state: { passedCartItems: JSON.stringify([{
                          productId: $setup.product.id,
                          productImage: $setup.product.imageLink,
                          productName: $setup.product.title,
                          productType: $setup.product.type,
                          quantity: $setup.cartItemQty,
                          unitPrice: $setup.product.sellingPrice,
                        }]) }
                      }
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_ion_icon, {
                                                          slot: "start",
                                                          icon: $setup.cardOutline
                                                        }, null, 8, ["icon"]),
                                                        _createTextVNode(" " + _toDisplayString($setup.t('buyNow')), 1)
                                                      ]),
                                                      _: 1
                                                    }, 8, ["router-link"]))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 1,
                                                class: "ion-margin-bottom",
                                                expand: "block",
                                                color: "medium",
                                                disabled: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString($setup.t('soldOut')), 1)
                                                ]),
                                                _: 1
                                              })),
                                          ($setup.userLoggedIn && $setup.product.likedByUser)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 2,
                                                class: "ion-margin-bottom",
                                                expand: "block",
                                                fill: "outline",
                                                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($setup.product, 'remove')), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: $setup.heart,
                                                    color: "danger"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('removeFromLikedItems')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          ($setup.userLoggedIn && !$setup.product.likedByUser)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 3,
                                                class: "ion-margin-bottom",
                                                expand: "block",
                                                fill: "outline",
                                                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => ($setup.updateUserLikedItem($setup.product, 'add')), ["stop"]))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: $setup.heartOutline
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('addToLikedItems')), 1)
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          ($setup.userLoggedIn)
                                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                                key: 4,
                                                expand: "block",
                                                fill: "outline",
                                                "router-link": {
                      name: 'FeedbackPage',
                      //params: { passedProduct: JSON.stringify(product) }
                      state: { passedProduct: JSON.stringify($setup.product) }
                    }
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_icon, {
                                                    slot: "start",
                                                    icon: $setup.chatbubbleEllipsesOutline
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString($setup.t('enquiry')), 1)
                                                ]),
                                                _: 1
                                              }, 8, ["router-link"]))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("p", _hoisted_7, _toDisplayString($setup.getLocalizedStr($setup.product, 'description', 'descriptionEn')), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, { size: "12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.productReviews.length) + " " + _toDisplayString($setup.t('ProductPage.numOfCustomerReviews')), 1)
                                    ]),
                                    _: 1
                                  }),
                                  ($setup.productReviews.length > 0)
                                    ? (_openBlock(), _createBlock(_component_ion_card_title, {
                                        key: 0,
                                        color: "warning"
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.floor($setup.productOverallRating), (i) => {
                                            return (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: i,
                                              icon: $setup.star
                                            }, null, 8, ["icon"]))
                                          }), 128)),
                                          ($setup.productOverallRating - Math.floor($setup.productOverallRating) > 0)
                                            ? (_openBlock(), _createBlock(_component_ion_icon, {
                                                key: 0,
                                                icon: $setup.starHalfOutline
                                              }, null, 8, ["icon"]))
                                            : _createCommentVNode("", true),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5-Math.ceil($setup.productOverallRating), (i) => {
                                            return (_openBlock(), _createBlock(_component_ion_icon, {
                                              key: i,
                                              icon: $setup.starOutline
                                            }, null, 8, ["icon"]))
                                          }), 128)),
                                          _createTextVNode(" " + _toDisplayString($setup.productOverallRating) + " / 5 ", 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }),
                              ($setup.product.purchasedByUser)
                                ? (_openBlock(), _createBlock(_component_ion_item, {
                                    key: 0,
                                    lines: "none"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_button, {
                                            fill: "outline",
                                            onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openNewReviewModal()))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_icon, {
                                                slot: "start",
                                                icon: $setup.pencil
                                              }, null, 8, ["icon"]),
                                              _createTextVNode(" " + _toDisplayString($setup.t('ProductPage.newReview')), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_row, null, {
                                default: _withCtx(() => [
                                  ($setup.loadingProductReviews)
                                    ? (_openBlock(), _createBlock(_component_ion_col, {
                                        key: 0,
                                        size: "12"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_component_ion_spinner)
                                          ])
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.productReviews, (review, index) => {
                                        return (_openBlock(), _createBlock(_component_ion_col, {
                                          size: "12",
                                          class: "ion-no-padding",
                                          key: review.id
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ion_card, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_card_header, null, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_card_subtitle, null, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" #" + _toDisplayString(index+1) + " ", 1),
                                                        _createVNode(_component_ion_chip, null, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_ion_avatar, null, {
                                                              default: _withCtx(() => [
                                                                _hoisted_9
                                                              ]),
                                                              _: 1
                                                            }),
                                                            _createVNode(_component_ion_label, null, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(review.username), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_ion_card_content, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("p", _hoisted_10, _toDisplayString(review.content), 1),
                                                    _createVNode(_component_ion_item, {
                                                      class: "ion-no-padding",
                                                      lines: "none"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Number(review.rating), (i) => {
                                                          return (_openBlock(), _createBlock(_component_ion_icon, {
                                                            key: i,
                                                            color: "warning",
                                                            icon: $setup.star
                                                          }, null, 8, ["icon"]))
                                                        }), 128)),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(5-review.rating, (i) => {
                                                          return (_openBlock(), _createBlock(_component_ion_icon, {
                                                            key: i,
                                                            color: "warning",
                                                            icon: $setup.starOutline
                                                          }, null, 8, ["icon"]))
                                                        }), 128)),
                                                        _createVNode(_component_ion_note, { slot: "end" }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString($setup.formatDate(review.createdAt)), 1)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}